// const setting = require('../config/setting');
const gsap = require("gsap/dist/gsap").gsap;
const ScrollToPlugin = require("gsap/ScrollToPlugin");
// const ScrollTrigger = require("gsap/ScrollTrigger");
gsap.registerPlugin(ScrollToPlugin);

export default class Main {

    btn_nav: any = document.querySelector(".btn-nav01");
    g_nav: any = document.querySelector(".global-nav");

	constructor() {
        this.btn_nav.addEventListener("click", () => {
            this.toggleMenu();
        });

        document.querySelectorAll(".anchor").forEach((el: any) => {
            el.addEventListener("click", (event: any) => {
                event.preventDefault();
                gsap.to(window, { duration: 0.5, scrollTo: event.currentTarget.getAttribute("href") });

                this.closeMenu();
            });
        });

        let shareBtn_twitter: any = document.querySelector('#sheaBtn-tw');
        shareBtn_twitter.addEventListener('click', () => {
            window.open('https://twitter.com/intent/tweet?url=https://colopl.co.jp/alicegearaegis/tv-anime/event/general_meeting_2024/&text=TVアニメ「アリス・ギア・アイギス Expansion」放送 1周年となる2024年4月に、アリスギアとして初の大型リアルイベントを開催決定！&hashtags=アリスギア,アリスギアEX', '_blank');
        });
	}

    toggleMenu() {
        this.g_nav.classList.toggle("is-active");

        if (this.g_nav.classList.contains("is-active")) {
            this.btn_nav.querySelector(".open").style.display = "none";
            this.btn_nav.querySelector(".close").style.display = "block";
        } else {
            this.btn_nav.querySelector(".open").style.display = "block";
            this.btn_nav.querySelector(".close").style.display = "none";
        }
    }

    closeMenu() {
        this.g_nav.classList.remove("is-active");
        this.btn_nav.querySelector(".open").style.display = "block";
        this.btn_nav.querySelector(".close").style.display = "none";
    }
}
